import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import styles from './AppHomeTemplate.module.css'
import { WEB_VERSION, YEAR_VERSION } from '../../../constants/env'
import { classes } from '../../../utils/css'

type AppHomeTemplateProps = {
  header: React.ReactNode
  menu: React.ReactNode
  children: React.ReactNode
  isMobile?: boolean
}

function AppHomeTemplate(props: AppHomeTemplateProps): JSX.Element {
  return (
    <Grid
      container
      direction='column'
      className={styles.homeTemplate}
      spacing={0}
    >
      <div className={styles.header}>{props.header}</div>
      <Grid container direction='row' wrap='nowrap'>
        <Grid
          className={classes(styles.menu, props.isMobile ? styles.mobile : '')}
        >
          {props.menu}
        </Grid>
        <Grid xs item>
          <Grid>{props.children}</Grid>
        </Grid>
      </Grid>
      <Grid className={styles.footer}>
        <Typography color='textSecondary' variant='caption'>
          Copyrights © 2014 - {YEAR_VERSION} & All Rights Reserved by
          Brightcomms / Ver.
          {WEB_VERSION}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default AppHomeTemplate
